import { render, staticRenderFns } from "./myPost.vue?vue&type=template&id=cf4c569e&scoped=true&"
import script from "./myPost.vue?vue&type=script&lang=js&"
export * from "./myPost.vue?vue&type=script&lang=js&"
import style0 from "./myPost.vue?vue&type=style&index=0&id=cf4c569e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4c569e",
  null
  
)

export default component.exports